// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"55557c3f","239":"83a15f31","732":"730dbfc3"}[chunkId] + ".chunk.js";
};